export default __webpack_public_path__ + "static/media/new-rickshaw.a4bba745.svg";